import { lightenColor } from "../../../utils/colors";
import { token } from "../../../../styled-system/tokens";

// Trellis brand colour palette
export const trellisPalette = [
  token("colors.trellisPalette.0"),
  token("colors.trellisPalette.1"),
  token("colors.trellisPalette.2"),
  token("colors.trellisPalette.3"),
  token("colors.trellisPalette.4"),
  token("colors.trellisPalette.5"),
  token("colors.trellisPalette.6"),
  token("colors.trellisPalette.7"),
  token("colors.trellisPalette.8"),
  token("colors.trellisPalette.9"),
  token("colors.trellisPalette.10"),
  token("colors.trellisPalette.11"),
  token("colors.trellisPalette.12"),
  token("colors.trellisPalette.13"),
  token("colors.trellisPalette.14"),
  token("colors.trellisPalette.15"),
  token("colors.trellisPalette.16"),
  token("colors.trellisPalette.17"),
] as const;

const createColor = (color: string) =>
  [1, 1.2, 1.4, 1.6, 1.8].map((percent) => lightenColor(color, percent)) as [string, string, string, string, string];

export const metricColors = {
  sales: createColor(trellisPalette[3]),
  units: createColor(trellisPalette[2]),
  roms: createColor(trellisPalette[0]),
  cost: createColor(trellisPalette[1]),
  acos: createColor(trellisPalette[14]),
  ntb: createColor(trellisPalette[1]),
  repeat: createColor(trellisPalette[3]),
  margin: createColor(trellisPalette[5]),
  metric1: createColor(trellisPalette[6]),
  metric2: createColor(trellisPalette[4]),
  metric3: createColor(trellisPalette[13]),
  metric4: createColor(trellisPalette[14]),
  metric5: createColor(trellisPalette[15]),
} as const;
